var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0d2a4f;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 9,
    y: 132.8,
    width: 498,
    height: 246.5,
    rx: 123.2,
    ry: 123.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.4,268.5h-173.3v-25.1h174.1l-66-66.4c0-1.2,15.5-16.2,16.6-16.7s1-.6,1.7,0l95.4,95.4-95.4,96c-.6.6-1,.3-1.7,0-1-.5-15.9-15.3-16.4-16.3l64.9-66.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnt);
export default __webpack_public_path__ + "static/media/bnt.ac3e93d69743cdde46a897ce117484a2.svg";
export { ForwardRef as ReactComponent };